import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    CardActions,
    CreateButton,
    ShowButton,
    SelectField
} from 'react-admin';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import LicenseEditButton from "../component/LicenseEditButton";

const LicenseActions = ({
                                    bulkActions,
                                    basePath,
                                    currentSort,
                                    displayedFilters,
                                    exporter,
                                    filters,
                                    filterValues,
                                    onUnselectItems,
                                    resource,
                                    selectedIds,
                                    showFilter,
                                    total
                                }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        <CreateButton basePath={basePath} label={"Додати"} />
    </CardActions>
);


const Empty = () => {
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Ліцензії - відсутні
            </Typography>
        </Box>
    );
};

export const LicenseList = (props) => (
    <List {...props}
          bulkActionButtons={false}
          perPage={25}
          title="Ліцензії"
          actions={<LicenseActions />}
          className="list-styles"
          empty={<Empty />}
    >
        <Datagrid>
            <TextField sortable={false} label="ID" source="id" />
            <TextField sortable={false} label="Номер ліцензії" source="licenseNumber" />
            <SelectField  sortable={false} label="Тип ліцензії" source="type" choices={[
                { id: 'MSP', name: 'ліцензія на провадження господарської діяльності з медичної практики' },
                { id: 'PHARMACY', name: 'ліцензія на провадження господарської діяльності з роздрібної торгівлі лікарськими засобами' },
                { id: 'PHARMACY_DRUGS', name: 'ліцензія на право провадження господарської діяльності з обігу наркотичних засобів, психотропних речовин і прекурсорів' }
            ]} />
            <TextField sortable={false} label="Напрям діяльності" source="whatLicensed" />
            <DateField sortable={false} label="Дата завершення дії ліцензії" source="expiryDate" locales="ru-RU" />
            <ShowButton label={"Переглянути"}/>
            <LicenseEditButton label={"Редагувати"} />
        </Datagrid>
    </List>
);

export default LicenseList;
